export interface CreateAppraisalDocDTO {
    uInspectId: string;
    uInspectMediaId: string;
    leadDocumentCategoryId: number;
}
